module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_7016.53c0bf36.png";